interface PaginateProps {
	items: JSX.Element[] | string[];
	pageIndex: number;
	pageSize: number;
}

/**
 * This is sort of like paginate except it just keeps adding on the next page instead of only returning a page.
 * @param items that need to be handled
 * @param pageIndex the current "pageIndex"
 * @param pageSize the allowed size for the page
 * @returns the items allowed
 */
const paginateCarousel = ({ items, pageIndex, pageSize }: PaginateProps) => {
	if (pageIndex === 0) {
		throw new Error("PageIndex cannot be 0");
	}
	const start = (pageIndex - 1) * pageSize;
	const end = start + pageSize;
	return items.slice(0, end);
};

export default paginateCarousel;
